/* global SideDrawer */

class CartDrawer extends SideDrawer {
    connectedCallback() {
        this.bindEvents();
    }

    bindEvents() {
        this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
        this.closeDrawerViaEventHandler = this.close.bind(this, null);
        document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
        document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
        document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
        this.addEventListener('on:cart-drawer:before-open', () => {
            theme.manuallyLoadImages(this);
            this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
        });
        this.addEventListener('on:cart:after-merge', () => {
            theme.manuallyLoadImages(this);
            this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
        });
    }

    disconnectedCallback() {
        document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
        document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
        document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    }

    /**
     * Handle when the drawer is opened via an event
     * @param {object} evt - Event object.
     */
    handleDrawerOpenViaEvent(evt) {
        this.open(evt.detail ? evt.detail.opener : null);
    }

    /**
     * Trigger refresh of contents
     */
    cartRefreshHandler() {
        this.querySelector('cart-form').refresh();
    }

    /**
     * Update section's cart-form element with new contents
     * @param {string} html - Whole-section HTML.
     */
    updateFromCartChange(html) {
        this.querySelector('cart-form').refreshFromHtml(html);
    }
}

window.customElements.define('cart-drawer', CartDrawer);


document.addEventListener('DOMContentLoaded', function () {
    const radioShipping = document.getElementById('radio-shipping');
    const radioPickup = document.getElementById('radio-pickup');
    const pickupContainer = document.getElementById('pickup-location-container');
    const locationSelect = document.getElementById('compulsory_Location');

    function updateDeliveryMethod() {
        if (radioShipping && radioShipping.checked) {
            pickupContainer.style.display = 'none';
            if (locationSelect) locationSelect.value = 'Shipping';
        } else if (radioPickup && radioPickup.checked) {
            pickupContainer.style.display = 'block';

            // Start with the store already chosen in the header, if there is one
            const hs = window.spartanStoreWidgetInstance && window.spartanStoreWidgetInstance.currentStore;
            if (locationSelect && locationSelect.value === 'Shipping' && hs && hs.city) {
                const want = String(hs.city).trim().toLowerCase();
                const match = Array.from(locationSelect.options).find((o) => (o.dataset.city || '').trim().toLowerCase() === want);
                if (match) { locationSelect.value = match.value; locationSelect.dataset.sorted = 'true'; }
            }

            // Trigger sort if not already done
            if (locationSelect && !locationSelect.dataset.sorted) {
                sortStoresByDistance();
            } else if (locationSelect && locationSelect.value === 'Shipping' && locationSelect.options.length > 1) {
                // If already sorted but still on "Shipping", default to nearest (index 1)
                locationSelect.selectedIndex = 1;
            } else if (locationSelect && locationSelect.value === 'Shipping') {
                // Fallback if not sorted yet
                locationSelect.value = locationSelect.options[1].value;
            }
        }
    }

    function sortStoresByDistance() {
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userLat = position.coords.latitude;
                const userLng = position.coords.longitude;

                const options = Array.from(locationSelect.options);
                const placeholder = options[0]; // "Select Store..."
                const storeOptions = options.slice(1); // The actual stores

                storeOptions.forEach(option => {
                    const lat = parseFloat(option.dataset.lat);
                    const lng = parseFloat(option.dataset.lng);
                    if (!isNaN(lat) && !isNaN(lng)) {
                        const distance = calculateDistance(userLat, userLng, lat, lng);
                        option.dataset.distance = distance;
                        // Keep original text to avoid double appending
                        if (!option.dataset.originalText) option.dataset.originalText = option.text;
                        option.text = `${option.dataset.originalText} (${distance.toFixed(1)} km)`;
                    }
                });

                storeOptions.sort((a, b) => {
                    return parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance);
                });

                // Re-build select
                locationSelect.innerHTML = '';
                locationSelect.appendChild(placeholder);
                storeOptions.forEach(option => locationSelect.appendChild(option));

                // Mark as sorted and select the nearest
                locationSelect.dataset.sorted = "true";
                locationSelect.selectedIndex = 1;
            },
            (error) => {
                console.log("Geolocation error or denied:", error);
                // Just select the first one if we can't sort
                if (locationSelect && locationSelect.value === 'Shipping') {
                    locationSelect.value = locationSelect.options[1].value;
                }
            }
        );
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371; // Radius of the earth in km
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Distance in km
    }

    function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    // Save the delivery choice on the cart, so the order shows "Delivery method" and "Pickup store"
    // (cart attributes appear under "Additional details" on the order in Shopify admin)
    function saveChoice() {
        const rp = document.getElementById('radio-pickup');
        const sel = document.getElementById('compulsory_Location');
        const pickup = !!(rp && rp.checked && sel && sel.value !== 'Shipping');
        const opt = pickup ? sel.options[sel.selectedIndex] : null;
        const store = opt ? (opt.dataset.originalText || opt.text).replace(/\s*\([\d.]+ km\)$/, '').trim() : '';
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: {
                'Delivery method': pickup ? 'Store pickup' : 'Delivery',
                'Pickup store': pickup ? 'Spartan Fitness ' + store : '',
                'Pickup store address': pickup ? [opt.dataset.address, opt.dataset.city, opt.dataset.province, opt.dataset.zip].map((x) => (x || '').trim()).filter(Boolean).join(', ') : '',
                'What location do you want to pick up from? ': pickup ? sel.value : 'Shipping'
            } })
        }).catch(() => {});
    }
    // Never hold up checkout for more than 2 s if the save is slow
    const saveChoiceQuick = () => Promise.race([saveChoice(), new Promise((r) => setTimeout(r, 2000))]);

    // Checkout: save the choice first, then go to checkout (pickup pre-fills the store address)
    document.body.addEventListener('click', async function (e) {
        const target = e.target.closest('a[href*="/checkout"], button[name="checkout"], #checkout-button, .checkout-buttons a');
        if (!target) return;
        // Second pass (after saving): let the button or link do exactly what it always did
        if (target.dataset.sfcSaved) { delete target.dataset.sfcSaved; return; }
        const rp = document.getElementById('radio-pickup');
        const sel = document.getElementById('compulsory_Location');
        const warn = document.querySelector('[data-sfc-warn]');
        if (rp && rp.checked && sel && sel.value === 'Shipping') {
            e.preventDefault(); e.stopPropagation();
            if (warn) warn.hidden = false;
            sel.focus();
            return;
        }
        e.preventDefault(); e.stopPropagation();
        target.setAttribute('aria-busy', 'true');
        await saveChoiceQuick();
        target.removeAttribute('aria-busy');
        const o = rp && rp.checked && sel ? sel.options[sel.selectedIndex] : null;
        if (!(o && o.dataset.address && o.dataset.city)) {
            // Delivery: carry on as normal (on the cart page this submits the form, so quantity and note changes are kept)
            target.dataset.sfcSaved = '1';
            target.click();
            return;
        }
        let url = '/checkout';
        {
            {
                const params = new URLSearchParams();
                params.append('checkout[shipping_address][address1]', o.dataset.address);
                params.append('checkout[shipping_address][city]', o.dataset.city);
                params.append('checkout[shipping_address][province]', o.dataset.province);
                params.append('checkout[shipping_address][zip]', o.dataset.zip);
                params.append('checkout[shipping_address][country]', o.dataset.country);
                params.append('checkout[shipping_address][company]', o.value); // same format as before, the team may rely on it
                url = '/checkout?' + params.toString();
            }
        }
        window.location.href = url;
    });

    // Listeners
    if (radioShipping) radioShipping.addEventListener('change', () => { updateDeliveryMethod(); saveChoice(); });
    if (radioPickup) radioPickup.addEventListener('change', () => { updateDeliveryMethod(); saveChoice(); });
    if (locationSelect) locationSelect.addEventListener('change', () => {
        const warn = document.querySelector('[data-sfc-warn]');
        if (warn && locationSelect.value !== 'Shipping') warn.hidden = true;
        saveChoice();
    });

    // Initial State Check
    updateDeliveryMethod();
});
